import editMemberDetailsTemplate from './edit_member_details.template.html';

class WbEditMemberDetailsController {

    constructor(LoadingService, $scope, AlertService) {
        'ngInject';

        const injectables = {
            LoadingService,
            $scope,
            AlertService
        };

        Object.assign(this, injectables);
    }

    $onInit() {
        // Initialise the loading spinner
        this.loader = this.LoadingService.$loader(this.$scope);
        this.resetValues();
    }

    resetValues() {
        this.memberValues = {
            first_name: this.member.first_name,
            last_name: this.member.last_name,
            mobile: this.member.mobile
        };
    }

    toggleEdit() {
        this.editMode = !this.editMode;
        if (this.editMode) { 
            delete this.status;
        } else {
            // Reset the values when leaving edit mode
            this.resetValues();
        }
    }

    hasChanges() {
        return this.member.first_name != this.memberValues.first_name ||
                this.member.last_name != this.memberValues.last_name ||
                this.member.mobile != this.memberValues.mobile;
    }

    applyChanges() {
        this.member.first_name = this.memberValues.first_name;
        this.member.last_name = this.memberValues.last_name;
        this.member.mobile = this.memberValues.mobile;
    }

    saveChanges() {
        // save to BB
        if (this.hasChanges()) {
            this.loader.notLoaded();
            // Copy the new values to the member object
            this.applyChanges();
            // Save the changes
            this.member.$put('self', {}, this.member.getPostData()).then(response => {
                console.log("Successfully saved member");
                this.loader.setLoaded();
                this.status = "saved";
                // Stop edit mode
                this.toggleEdit();
                this.AlertService.success({ msg: 'Successfully saved member details' });
            }, err => {
                // Show an error
                console.err("Failed to save member", err);
                this.error = err;
                this.status = "error";
                this.AlertService.success({ msg: 'Failed to save member details' });
            });
        } else {
            this.toggleEdit();
        }
    }
}

const WbEditMemberDetailsComponent = {
    templateUrl: editMemberDetailsTemplate.id,
    controller: WbEditMemberDetailsController,
    controllerAs: '$wbEditMemberDetailsCtrl',
    bindings: {
        member: '<'
    }
};

angular
    .module('westBerkshireEvents.editMember')
    .component('wbEditMemberDetails', WbEditMemberDetailsComponent);

export default WbEditMemberDetailsController;


// WEBPACK FOOTER //
// ../src/public/javascripts/edit-member-details/edit_member_details.component.js